module.exports = __webpack_public_path__ + "img/car.fe380ef7.svg";